import { Button, Row } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { keepState } from './../../../../../actions/appAction';
import history from './../../../../../services/history';

class Utility extends Component {
    render() {
        let { link } = this.props
        return (
            <Row className="footer-component " id='add-order'>
                <div className="fix-footer modal-add-order">
                    <div className='navbar-cancel-save-add-order'>
                        <Button className="cancel button-green-y-ship"
                            onClick={() => {
                                history.push(link)
                                this.props.keepState(true)
                            }}
                        >Close</Button>
                    </div>
                </div>
            </Row>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        keepState: payload => {
            dispatch(keepState(payload))
        },
    }
}

export default connect(
    null,
    mapDispatchToProps
)(Utility)


// WEBPACK FOOTER //
// ./src/containers/shipments/detail-shipment/components/utility/index.js